import './testOrderAttachmentsDetailsComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import TestOrderAttachmentsViewComponent from "./test-order-attachments-view/testOrderAttachmentsViewComponent";
import TestOrderAttachmentsEditComponent from "./test-order-attachments-edit/testOrderAttachmentsEditComponent";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig} from "../../../../constants";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import commonService from "../../../../shared/services/common.service";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";

interface TestOrderAttachmentsDetailsComponentProps {
    testOrderDetails: any;
    onModeChange: Function;
}

const TestOrderAttachmentsDetailsComponent = (props: TestOrderAttachmentsDetailsComponentProps) => {

        const {testOrderDetails, onModeChange} = props;
        const [mode, setMode] = useState<"view" | "edit">("view");
        const [testOrderAttachmentsList, setTestOrderAttachmentsList] = useState<any>([]);
        const [isTestOrderAttachmentsListLoading, setIsTestOrderAttachmentsListLoading] = useState<boolean>(false);
        const [isTestOrderAttachmentsListLoaded, setIsTestOrderAttachmentsListLoaded] = useState<boolean>(false);
        const [isTestOrderAttachmentsListLoadingFailed, setIsTestOrderAttachmentsListLoadingFailed] = useState<boolean>(false);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);


        const handleTestOrderAttachments = useCallback((updatedTestOrderAttachments: any) => {
            setTestOrderAttachmentsList(updatedTestOrderAttachments);
            setMode("view");
        }, []);

        const handleEditCancel = useCallback(() => {
            setMode("view");
        }, []);

        const getTestOrderAttachmentsList = useCallback(() => {
            setIsTestOrderAttachmentsListLoading(true);
            setIsTestOrderAttachmentsListLoaded(false);
            setIsTestOrderAttachmentsListLoadingFailed(false);
            const payload = {}
            CommonService._testOrder.getTestOrderAttachments(testOrderDetails?.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        setTestOrderAttachmentsList(response.data);
                    }
                    setIsTestOrderAttachmentsListLoading(false);
                    setIsTestOrderAttachmentsListLoaded(true);
                    setIsTestOrderAttachmentsListLoadingFailed(false);
                })
                .catch((error: any) => {
                    setIsTestOrderAttachmentsListLoading(false);
                    setIsTestOrderAttachmentsListLoaded(false);
                    setIsTestOrderAttachmentsListLoadingFailed(true);
                });
        }, [testOrderDetails])


        useEffect(() => {
            if (testOrderDetails.id) {
                getTestOrderAttachmentsList();
            }
        }, [testOrderDetails, getTestOrderAttachmentsList]);

        useEffect(() => {
            onModeChange(mode)
        }, [mode, onModeChange]);

        return (
            <div className="test-order-attachments-component details-tab-data-wrapper">

                {
                    isTestOrderAttachmentsListLoading && <div className="details-screen-loading-icon">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    isTestOrderAttachmentsListLoadingFailed && <></>
                }
                {
                    isTestOrderAttachmentsListLoaded && <>
                        {
                            mode === "view" && <TestOrderAttachmentsViewComponent
                                testOrderAttachments={testOrderAttachmentsList}
                                onEditModeOpen={() => {
                                    setMode("edit")
                                }}
                            />
                        }
                        {
                            mode === "edit" &&
                            commonService.checkAccess('TestOrder', 'testOrderEdit', currentUser?.userAccessModules) &&
                            <TestOrderAttachmentsEditComponent
                                testOrderID={testOrderDetails.id}
                                testOrderAttachments={testOrderAttachmentsList}
                                onUpdateComplete={handleTestOrderAttachments}
                                onEditCancel={handleEditCancel}
                            />
                        }

                    </>
                }
            </div>
        )
    }

;

export default TestOrderAttachmentsDetailsComponent;